module.exports = __webpack_public_path__ + "img/logo_text.4a4d7dfc.png";